import Lenis from "lenis";

const isTouch = window.matchMedia("(pointer: coarse)").matches;
const canHover = window.matchMedia("(hover: hover)").matches;

document.addEventListener("DOMContentLoaded", function () {
 // ーーーーーーーーーーーーーーーーーーーーー
 // バグ対応
 // iOSでの focus 残留によるバグ対応
 // 対象外要素をタップしたら blur する(focus取る)
 // select, input, textarea 対応
 // ーーーーーーーーーーーーーーーーーーーーー
 // dataタイプ選択後、他要素のタッチではfoucusできないバグは未解決
 // ーーーーーーーーーーーーーーーーーーーーー
 //  if (isIOS) {
 //   document.addEventListener(
 //    "touchstart",
 //    function (e) {
 //     const active = document.activeElement;
 //     if (active && (active.tagName === "SELECT" || active.tagName === "TEXTAREA" || (active.tagName === "INPUT" && !["checkbox", "radio", "button", "submit", "reset", "file", "hidden"].includes(active.type)))) {
 //      // 対象外要素をタップしたら blur する
 //      if (!active.contains(e.target) && e.target !== active) {
 //       active.blur();
 //       // alert("off");
 //      }
 //     }
 //    },
 //    { passive: true }
 //   );
 //  }
 // });
 // document.addEventListener("DOMContentLoaded", () => {
 //  // ーーーーーーーーーーーーーーーーーーーーー
 //  // tabの選択制御
 //  // .js-disabledついたらタブ選択できない
 //  // ーーーーーーーーーーーーーーーーーーーーー
 //  const elements = document.querySelectorAll(".js-disabled");
 //  elements.forEach((el) => {
 //   el.setAttribute("tabindex", "-1");
 //  });
});

// document.addEventListener("DOMContentLoaded", function () {
//  // ーーーーーーーーーーーーーーーーーーーーー
//  // スクロールバー
//  // iosにも常時出力するためプラグイン
//  // 複数要素
//  // ーーーーーーーーーーーーーーーーーーーーー
//  var {
//   OverlayScrollbars,
//   ScrollbarsHidingPlugin, //プラグイン
//   SizeObserverPlugin, //プラグイン
//   ClickScrollPlugin, //プラグイン
//  } = OverlayScrollbarsGlobal;

//  // 複数使う場合
//  OverlayScrollbars.plugin([SizeObserverPlugin, ClickScrollPlugin]);

//  const scroll = document.querySelectorAll(".js-scroll-tar");
//  scroll.forEach((el) => {
//   OverlayScrollbars(el, {});
//  });
//  const scrollX = document.querySelectorAll(".js-scroll-horizontal-tar");
//  scrollX.forEach((el) => {
//   OverlayScrollbars(el, {});
//  });

//  const scrollSideBar = document.querySelectorAll(".js-scroll-side-tar");
//  scrollSideBar.forEach((el) => {
//   OverlayScrollbars(el, {});
//  });
// });

// document.addEventListener("DOMContentLoaded", function () {
//  // ーーーーーーーーーーーーーーーーーーーーー
//  // モバイルのナビゲーションの高さ
//  // dvhが効かないデバイスのために対応
//  // ーーーーーーーーーーーーーーーーーーーーー
//  const container = document.querySelector(".js-mobile-h");
//  const viewport = window.visualViewport;

//  if (!container || !viewport) return;

//  // resizeHandler: 現在の viewport 高さを CSS 変数に設定
//  function resizeHandler() {
//   const scale = viewport.scale;
//   // ズームした時は高さ変えない
//   if (Math.abs(scale - 1) >= 0.01) {
//    // console.log("ズーム中 → スキップ");
//    return;
//   }
//   const height = viewport.height;
//   container.style.setProperty("--mobile-height", `${height}px`);
//   console.log(`高さ：${height}px`);
//  }

//  // イベント登録状態を保持
//  let isRegistered = false;

//  // 初期表示時の処理
//  if (window.innerWidth < 1024) {
//   viewport.addEventListener("resize", resizeHandler);
//   isRegistered = true;
//   requestAnimationFrame(resizeHandler); // 競合回避のため少し遅延して実行
//  }

//  // ウィンドウ幅変更時の処理
//  window.addEventListener("resize", function () {
//   if (window.innerWidth >= 1024) {
//    if (isRegistered) {
//     viewport.removeEventListener("resize", resizeHandler);
//     isRegistered = false;
//    }
//    container.style.removeProperty("--mobile-height");
//   } else {
//    requestAnimationFrame(resizeHandler);
//    if (!isRegistered) {
//     let prevScale = window.visualViewport.scale;
//     const currentScale = window.visualViewport.scale;

//     // ズームしてないときだけ処理
//     if (Math.abs(currentScale - 1) < 0.01) {
//      requestAnimationFrame(resizeHandler);
//     }

//     // // 状態更新（必要なら）
//     // prevScale = currentScale;
//     isRegistered = true;
//    }
//   }
//  });
// });

// 画像などもすべて読み込まれたら
window.addEventListener("load", () => {
 const mv = document.querySelector(".js-mv");
 if (mv) {
  // ディレイ付きでクラス付与（任意）
  setTimeout(() => {
   mv.classList.add("is-show");
  }, 100); // 100msディレイ（ブラウザの描画タイミングに合わせる）
 }
});

// スクロールの際に滑らかに移動停止
document.addEventListener("DOMContentLoaded", function () {
 const lenis = new Lenis({
  lerp: 0.1,
 });

 function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
 }

 requestAnimationFrame(raf);
});

// data-lenis-prevent → すべての入力イベントを防ぐ
// data-lenis-prevent-wheel → ホイールだけ防ぐ
// data-lenis-prevent-touch → タッチだけ防ぐ

// スクロールコンテンツアニメーション
window.addEventListener("load", function () {
 const targets = document.querySelectorAll(".js-clip-text");

 const observer = new IntersectionObserver(
  (entries) => {
   entries.forEach((entry) => {
    if (entry.isIntersecting) {
     entry.target.classList.add("is-show");
     observer.unobserve(entry.target); // 一度だけ付与
    }
   });
  },
  {
   root: null, // viewport
   threshold: [0, 1], // 一部でも入ればOK
   rootMargin: "-20% 0%", // 上下を10%分縮める → 中央80%の範囲
  },
 );

 targets.forEach((target) => {
  observer.observe(target);
 });
});
window.addEventListener("load", function () {
 // 交差を監視する要素を準備
 const targets = document.querySelectorAll(".js-scroll-animation");

 // Intersection Observerの設定
 const options = {
  root: null,
  rootMargin: "-10% -15%",
  // threshold: [0, 0.25, 0.5, 0.75, 1],
  threshold: 0,
 };

 const observer = new IntersectionObserver(intersect, options);

 // 対象の要素をそれぞれ監視する
 targets.forEach((target) => {
  observer.observe(target);
 });

 // 交差したときに実行する関数
 function intersect(entries) {
  entries.forEach((entry) => {
   // console.log("isIntersecting:" + entry.isIntersecting);
   // if (entry.isIntersecting) {
   if (entry.isIntersecting) {
    entry.target.classList.add("is-show");
    observer.unobserve(entry.target); //監視を終了する
   }
  });
 }
});

// window.addEventListener("load", function () {
//  // ====== 既存コード ======
//  const targets = document.querySelectorAll(".js-scroll-animation");
//  const options = {
//   root: null,
//   rootMargin: "-10% 0% -25% 0%",
//   threshold: 0,
//  };
//  const observer = new IntersectionObserver(intersect, options);
//  targets.forEach((t) => observer.observe(t));

//  function intersect(entries) {
//   let anyIntersecting = false;

//   entries.forEach((entry) => {
//    // デバッグ用の表示（枠色/アウトライン/バッジ更新）
//    updateDebugForEntry(entry);

//    if (entry.isIntersecting) {
//     anyIntersecting = true;
//     entry.target.classList.add("is-show");
//     observer.unobserve(entry.target); // 本番ロジック（監視終了）
//    }
//   });

//   // 観測枠の色を「何か当たってるか」で変える
//   debugRoot.classList.toggle("is-hit", anyIntersecting);
//  }

//  // ====== ここからデバッグ可視化 ======
//  // rootMargin を % / px いずれでも解釈して、ビューポート上に「実際の観測枠」を描く
//  function parseRootMarginToInsets(rootMarginStr) {
//   // 例: "10px 20px 30px 40px" | "10% 20%" | "-10% -15%"
//   const parts = rootMarginStr.trim().split(/\s+/);
//   // CSS の省略記法に準拠（1〜4個）
//   const [t, r, b, l] = (function (arr) {
//    if (arr.length === 1) return [arr[0], arr[0], arr[0], arr[0]];
//    if (arr.length === 2) return [arr[0], arr[1], arr[0], arr[1]];
//    if (arr.length === 3) return [arr[0], arr[1], arr[2], arr[1]];
//    return [arr[0], arr[1], arr[2], arr[3]];
//   })(parts);

//   const vw = window.innerWidth;
//   const vh = window.innerHeight;

//   function toPx(token, base) {
//    if (token.endsWith("%")) {
//     const v = parseFloat(token);
//     return (v / 100) * base;
//    }
//    return parseFloat(token); // px 想定
//   }

//   // rootMargin は「root 矩形を外側に(+)/内側に(-)拡張」する値
//   // 画面に描くときは「縮む分=負値の絶対値」を inset にするのが分かりやすい
//   const mt = toPx(t, vh);
//   const mr = toPx(r, vw);
//   const mb = toPx(b, vh);
//   const ml = toPx(l, vw);

//   // 負の margin は「内側へ縮む」。よって inset に正で反映。
//   // 正の margin は「外へ広がる」= 画面外になるので 0 に丸める（簡易表示）
//   const insetTop = mt < 0 ? Math.min(vh, Math.abs(mt)) : 0;
//   const insetRight = mr < 0 ? Math.min(vw, Math.abs(mr)) : 0;
//   const insetBottom = mb < 0 ? Math.min(vh, Math.abs(mb)) : 0;
//   const insetLeft = ml < 0 ? Math.min(vw, Math.abs(ml)) : 0;

//   return { insetTop, insetRight, insetBottom, insetLeft };
//  }

//  // ルート枠の可視化
//  const debugRoot = document.createElement("div");
//  debugRoot.className = "io-debug-rootbox";
//  document.body.appendChild(debugRoot);

//  const badge = document.createElement("div");
//  badge.className = "io-debug-badge";
//  document.body.appendChild(badge);

//  function positionDebugRootBox() {
//   const { insetTop, insetRight, insetBottom, insetLeft } = parseRootMarginToInsets(options.rootMargin || "0px");

//   debugRoot.style.top = insetTop + "px";
//   debugRoot.style.right = insetRight + "px";
//   debugRoot.style.bottom = insetBottom + "px";
//   debugRoot.style.left = insetLeft + "px";
//  }

//  function updateDebugForEntry(entry) {
//   // 要素のアウトライン（入った/出た）
//   if (entry.isIntersecting) {
//    entry.target.classList.add("io-debug-target-in");
//    entry.target.classList.remove("io-debug-target-out");
//   } else {
//    entry.target.classList.add("io-debug-target-out");
//    entry.target.classList.remove("io-debug-target-in");
//   }
//   // バッジ表示（ざっくり）
//   badge.textContent = `isIntersecting: ${entry.isIntersecting} | ratio: ${entry.intersectionRatio.toFixed(2)}`;
//  }

//  positionDebugRootBox();
//  window.addEventListener("resize", positionDebugRootBox);

//  // デバッグ ON/OFF（D キーで切替）
//  let debugOn = true;
//  function toggleDebug() {
//   debugOn = !debugOn;
//   debugRoot.style.display = debugOn ? "" : "none";
//   badge.style.display = debugOn ? "" : "none";
//   document.querySelectorAll(".io-debug-target-in, .io-debug-target-out").forEach((el) => (el.style.outline = debugOn ? "" : "none"));
//  }
//  window.addEventListener("keydown", (e) => {
//   if (e.key.toLowerCase() === "d") toggleDebug();
//  });
// });

// /* デバッグ表示用の最低限のスタイル */
// .io-debug-rootbox {
//  position: fixed;
//  inset: 0;
//  border: 2px dashed #e91e63;
//  /* 観測枠（rootMargin 反映後） */
//  box-shadow: 0 0 0 9999px rgba(233, 30, 99, .08);
//  /* 枠外を薄くマスク */
//  pointer-events: none;
//  z-index: 999999;
// }

// .io-debug-rootbox.is-hit {
//  border-color: #81ff87;
//  box-shadow: 0 0 0 9999px rgba(46, 125, 50, .08);
// }

// .io-debug-badge {
//  position: fixed;
//  right: 8px;
//  bottom: 8px;
//  padding: 4px 8px;
//  font: 12px/1.4 system-ui, sans-serif;
//  background: rgba(0, 0, 0, .7);
//  color: #fff;
//  border-radius: 6px;
//  z-index: 1000000;
//  pointer-events: none;
// }

// .io-debug-target-in {
//  outline: 3px solid #81ff87 !important;
// }

// .io-debug-target-out {
//  outline: 3px solid #e53935 !important;
// }

// jQuery(function ($) {
//  //  // ーーーーーーーーーーーーーーーーーーーーー
//  //  // Safariのmobileタッチ反応（active）対応
//  //  // 全デバイス適応
//  //  // ーーーーーーーーーーーーーーーーーーーーー
//  //  if ($(".js-active-tar").length) {
//  //   $(".js-active-tar").on("pointerdown", function (e) {
//  //    $(this).addClass("is-active"); // 押した瞬間に反応
//  //   });
//  //   $(".js-active-tar").on("pointerup pointercancel", function (e) {
//  //    const $el = $(this);
//  //    setTimeout(function () {
//  //     $el.removeClass("is-active");
//  //    }, 60);
//  //   });
//  //  }
//  //  // ーーーーーーーーーーーーーーーーーーーーー
//  //  // ハンバーガーメニュー
//  //  // ーーーーーーーーーーーーーーーーーーーーー
//  // if ($(".js-hum").length && $(".js-sp-nav").length) {
//  //  $(".js-hum").on("click", function () {
//  //   $(this).toggleClass("is-open is-close");
//  //   $(".is-sp-nav").toggleClass("is-open is-close");
//  //  });
//  // }
// });
// morph-script.js

document.addEventListener("DOMContentLoaded", () => {
 const hamburger = document.querySelector(".js-hum");
 const spNav = document.querySelector("nav.js-sp-nav");
 const spBg = document.createElement("div");
 if (spNav) {
  // idを付ける
  spNav.id = "morph-menu";

  // classを追加（すでにあるなら何もしない）
  spNav.classList.add("nav-morph");

  // aria-hiddenを付ける
  if (!spNav.hasAttribute("aria-hidden")) {
   spNav.setAttribute("aria-hidden", "true");
  }

  // 背景アニメーション要素作成
  spBg.className = "l_header__sp_bg";
  // ナビの兄弟要素として挿入
  spNav.parentNode.insertBefore(spBg, spNav.nextSibling);
 }

 hamburger.addEventListener("click", () => {
  hamburger.classList.toggle("active");
  spNav.classList.toggle("active");
  spBg.classList.toggle("active");

  const isOpen = hamburger.classList.contains("active");
  hamburger.setAttribute("aria-expanded", isOpen);
  spNav.setAttribute("aria-hidden", !isOpen);
 });
});

// projectSPのアコーディオンの開閉
jQuery(function ($) {
 function closeItem($item) {
  let $body = $item.find(".js-acc-body").first();
  let el = $body.get(0);
  if (!el) return;

  // 現在の高さを固定してから 0 にする（アニメさせる）
  el.style.height = el.scrollHeight + "px";
  // 次フレームで0へ
  requestAnimationFrame(function () {
   el.style.height = "0px";
  });

  $item.removeClass("is-open");
 }

 function openItem($item) {
  let $body = $item.find(".js-acc-body").first();
  let el = $body.get(0);
  if (!el) return;

  // いったん0にしてから実高さへ
  el.style.height = "0px";
  $item.addClass("is-open");

  requestAnimationFrame(function () {
   el.style.height = el.scrollHeight + "px";
  });

  // アニメ後は auto にして内容変化に追随させる
  let onEnd = function (e) {
   if (e.propertyName !== "height") return;
   el.style.height = "auto";
   el.removeEventListener("transitionend", onEnd);
  };
  el.addEventListener("transitionend", onEnd);
 }

 $(document).on("click", ".js-acc-btn", function () {
  let $item = $(this).closest(".js-acc-item");
  let isOpen = $item.hasClass("is-open");

  // 他は閉じる（1つだけ開く）
  $item.siblings(".js-acc-item").each(function () {
   if ($(this).hasClass("is-open")) {
    closeItem($(this));
   }
  });

  // 自分はトグル
  if (isOpen) {
   closeItem($item);
  } else {
   openItem($item);
  }
 });

 // 初期で is-open が付いてる場合の整形
 $(".js-acc-item.is-open").each(function () {
  let $item = $(this);
  let $body = $item.find(".js-acc-body").first();
  let el = $body.get(0);
  if (el) {
   el.style.height = "auto";
  }
 });
});

// svgの長さ確認のため
// const paths = document.querySelectorAll(".hamburger-morph__line");
// paths.forEach((path, i) => {
//  console.log(i, path.getTotalLength());
// });
